import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/collections/license.collections.query.gql"
import type {
  InvoiceCollectionsQuery,
  InvoiceCollectionsQueryVariables,
} from "@/v2-backoffice-client/license/collections/__types__/license.collections.query"

export function useInvoiceCollectionsQuery(
  options?: QueryHookOptions<
    InvoiceCollectionsQuery,
    InvoiceCollectionsQueryVariables
  >,
) {
  return useQuery<InvoiceCollectionsQuery, InvoiceCollectionsQueryVariables>(
    query,
    options,
  )
}
